import React, { useEffect, useState } from "react";
import "./Awards.css";
import Navber from "../../Components/Navber";

const Awards = () => {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://admin.jayrajgroup.org/api/awards")
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setAwards(data.data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="awards-loader">Loading Awards...</div>;
  }

  return (
    <section className="awards-page">
        <Navber/>
      {/* HERO */}
      <div className="awards-hero">
        <h1>🏆 Awards & Certificates</h1>
        <p>Recognitions that reflect our excellence & achievements</p>
      </div>

      {/* LIST */}
      <div className="awards-container">
        {awards.map((award) => (
          <div className="award-card" key={award.id}>
            {/* IMAGE GRID */}
            <div className="award-images">
              {award.media.map((img) => (
                <img
                  key={img.id}
                  src={img.full_url}
                  alt={award.title}
                />
              ))}
            </div>

            {/* CONTENT */}
            <div className="award-content">
              <h2>{award.title}</h2>
              <h4>{award.sub_title}</h4>

              <div
                className="award-description"
                dangerouslySetInnerHTML={{ __html: award.description }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Awards;
